/// <amd-module name="SuiteCommerce.GiftCertificate.Main.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.Main.Configuration", ["require", "exports", "SuiteCommerce.GiftCertificate.Utils.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MainConfiguration = void 0;
    var MainConfiguration = /** @class */ (function (_super) {
        __extends(MainConfiguration, _super);
        function MainConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(MainConfiguration, "hideInventoryTypesFromFacets", {
            get: function () {
                return this.get('giftcertadvanced.hideInventoryTypesFromFacets');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(MainConfiguration, "enableGiftCertShopping", {
            get: function () {
                return this.get('giftcertbalance.enableGiftCertShopping');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(MainConfiguration, "enableGiftCertMyAccount", {
            get: function () {
                return this.get('giftcertadvanced.enableGiftCertMyAccount');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(MainConfiguration, "dateFormat", {
            get: function () {
                return this.get('giftcertadvanced.dateFormat');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(MainConfiguration, "priceRange", {
            get: function () {
                return this.get('giftcertadvanced.priceRange');
            },
            enumerable: false,
            configurable: true
        });
        return MainConfiguration;
    }(Configuration_1.Configuration));
    exports.MainConfiguration = MainConfiguration;
});
